<template>
  <div>
    <header id="header">
      <div class="inn">
        <div class="brand">
          <a href="" class="logo"><img height="43" src="/images/logo_without_icon.png"></a>
          <a v-if="backLbl" href="javascript:;" class="back" @click="goBackToList">&lt; {{ backLbl }}</a>
        </div>
        <a href="javascript:;" class="menu-toggle" @click="toggleDrawer">Menu</a>
        <a v-if="numberOfNotifications" href="javascript:;" @click="goToAccount" class="noti">{{ numberOfNotifications }}</a>
      </div>
    </header>

    <div :class="{drawer: true, reveal: drawer}" v-click-outside="hideDrawer">
      <a href="javascript:;" class="close" @click="toggleDrawer">Close</a>
      <div class="inn">
        <ul class="main-nav">
          <li @click="hideDrawer"><router-link :to="{name: 'dashboard'}" :class="{active: isActive('dashboard')}">Dashboard</router-link></li>
          <li @click="hideDrawer"><router-link :to="{name: 'jobs'}" :class="{active: isActive('jobs')}">Jobs</router-link></li>
          <template v-if="IS_SUPER_ADMIN">
            <li @click="hideDrawer"><router-link :to="{name: 'notes'}" :class="{active: isActive('notes')}">Notes</router-link></li>
            <li @click="hideDrawer"><router-link :to="{name: 'clients'}" :class="{active: isActive('clients')}">Clients</router-link></li>
            <li @click="hideDrawer"><router-link :to="{name: 'orders'}" :class="{active: isActive('orders')}">Orders</router-link></li>
            <li @click="hideDrawer"><router-link :to="{name: 'quotes'}" :class="{active: isActive('quotes')}">Quotes</router-link></li>
            <li @click="hideDrawer"><router-link :to="{name: 'invoices'}" :class="{active: isActive('invoices')}">Invoices</router-link></li>
          </template>
          <li v-if="!IS_CLIENT" @click="hideDrawer"><router-link :to="{name: 'time'}" :class="{active: isActive('time')}">Time</router-link></li>
          <li @click="hideDrawer" v-if="IS_SUPER_ADMIN || IS_CLIENT_MANAGER"><router-link :to="{name: 'settings'}" :class="{active: isActive('settings')}">Settings</router-link></li>
        </ul>
      </div>
      <div class="user-nav">
        <div @click="hideDrawer" class="avatar">
          <span v-if="numberOfNotifications" class="noti">{{ numberOfNotifications }}</span>
          <a @click="goToAccount" class="user-initials">{{ CURRENT_USER?CURRENT_USER.initials:'' }}</a>
        </div>
        <a href="javascript:;" @click="logout">Logout</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import auth from '@/services/auth'

export default {
  data () {
    return {
      drawer: false,
      env: process.env,
      show_drawer_time: 0,
      routes_have_list: ['quote', 'order', 'note', 'job', 'client', 'invoice', 'settings-email-template']
    }
  },
  watch: {
    drawer ( newVal ) {
      if ( newVal ) {
        document.body.classList.add('menu-visible')
      }
      else {
        document.body.classList.remove('menu-visible')
      }
    }
  },
  computed: {
    ...mapGetters(['CURRENT_USER', 'IS_CLIENT', 'IS_CLIENT_MANAGER', 'IS_SUPER_ADMIN']),
    ...mapState({
      numberOfUnreadComments: state => state.option.numberOfUnreadComments,
      numberOfPendingRequests: state => state.option.numberOfPendingRequests
    }),
    numberOfNotifications() {
      return this.IS_SUPER_ADMIN ? this.numberOfUnreadComments + this.numberOfPendingRequests : this.numberOfUnreadComments;
    },
    backLbl(){
      let self = this, routeName = self.$route.name;
      if (self.routes_have_list.indexOf(routeName) >= 0) {
        return 'Back to all ' + routeName.replace('-', ' ') + 's';
      }
      return null;
    }
  },
  methods: {
    logout () {
      let self = this;

      auth.logout().then(() => {
        self.$localStorage.remove( 'access_token' );
        self.$router.push({ name: 'login' });
      });
    },
    isActive (menu) {
      let self = this, routeName = self.$route.name, aRoutes = [];
      switch (menu) {
        case 'settings':
          aRoutes = ['settings', 'settings-team', 'settings-user-types', 'settings-cost-categories', 'settings-cost-matrix', 'settings-client-users', 'settings-xero', 'settings-email-templates'];
          break;
        case 'time':
          aRoutes = ['time'];
          break;
        case 'timesheets':
          aRoutes = ['timesheets'];
          break;
        case 'invoices':
          aRoutes = ['invoices', 'invoice', 'invoice-items'];
          break;
        case 'quotes':
          aRoutes = ['quotes', 'quote', 'quote-items', 'quote-invoices'];
          break;
        case 'orders':
          aRoutes = ['orders', 'order'];
          break;
        case 'contacts':
          aRoutes = ['contacts', 'contact'];
          break;
        case 'notes':
          aRoutes = ['notes', 'note'];
          break;
        case 'jobs':
          aRoutes = ['jobs', 'job'];
          break;
        case 'dashboard':
          aRoutes = ['dashboard'];
          break;
        case 'clients':
          aRoutes = ['clients', 'client', 'client-members', 'client-projects', 'client-notes'];
          break;
        case 'users':
          aRoutes = ['users'];
          break;
        case 'cost-matrix':
          aRoutes = ['cost-matrix'];
          break;
      }
      return aRoutes.indexOf(routeName) >= 0;
    },
    toggleDrawer () {
      this.drawer = !this.drawer;
      if (this.drawer)
        this.show_drawer_time = new Date().getTime();
      else
        this.show_drawer_time = 0;
    },
    hideDrawer () {
      /* Click out side the drawer */
      let now = new Date().getTime();
      if(now - this.show_drawer_time > 50 && this.drawer){
        this.drawer = false;
      }
    },
    goBackToList () {
      let self = this, routeName = self.$route.name;
      if (self.routes_have_list.indexOf(routeName) >= 0) {
        this.$router.push({name: routeName + 's'});
      }
    },
    goToAccount () {
      let self = this;
      if (self.numberOfNotifications == 0) {
        self.$router.push({
          name: 'account'
        });
      } else {
        /* If we have notifications, go to Notifications tab */
        if (self.IS_CLIENT) {
          self.$router.push({
            name: 'notifications'
          });
        } else {
          if (self.numberOfUnreadComments) {
            self.$router.push({
              name: 'account-notifications'
            });
          } else {
            self.$router.push({
              name: 'job-requests'
            });
          }
        }
      }

    }
  }
}
</script>
